angular.module('unergie.main')
.directive('b2gContactModif', (AlertManager, DataAccess, MetaWatcher, ErrorCatcher) =>
    ({
        restrict: 'E',
        templateUrl: '/states/csrB2gHome/contacts/b2gContactModif.html',
        scope: {
            contact: '=',
            field: '=',
        },
        link($scope) {
            $scope.mUCT = {
                value: undefined,
            }

            $scope.mUCF = {
                value: {
                    required: true,
                    label: 'Modifier pour tous les paquets',
                },
            }

            $scope.generateUpdateContactTemplate = () => {
                $scope.mUCT = { value: $scope.contact[$scope.field] }
                switch ($scope.field) {
                    case 'civ':
                        $scope.mUCF.value.type = 'radio'
                        $scope.mUCF.value.required = true
                        $scope.mUCF.value.enum = [
                            { label: 'M.', value: 'M.' },
                            { label: 'Mme', value: 'Mme' },
                        ]
                        break
                    case 'phone':
                        $scope.mUCF.value.type = 'phone-all'
                        $scope.mUCF.value.required = true
                        delete $scope.mUCF.value.enum
                        break
                    case 'mail':
                        $scope.mUCF.value.type = 'email'
                        $scope.mUCF.value.required = true
                        delete $scope.mUCF.value.enum
                        break
                    case 'role':
                    case 'comment':
                        $scope.mUCF.value.type = 'text'
                        $scope.mUCF.value.required = false
                        delete $scope.mUCF.value.enum
                        break
                    default:
                        $scope.mUCF.value.type = 'text'
                        $scope.mUCF.value.required = true
                        delete $scope.mUCF.value.enum
                }
            }

            $scope.massUpdateContact = () => {
                const payload = _.assign(_.pick($scope.contact, ['id_account', 'affectation']), {
                    [$scope.field]: $scope.mUCT.value,
                })
                $scope.updating = true
                return DataAccess.massUpdateCategoryContacts({}, payload).$promise.then((response) => {
                    AlertManager.success('Contacts modifiés')
                    MetaWatcher.notif('MNG_CONTACTS_CHANGED')
                })
                .catch(ErrorCatcher)
                .finally(() => {
                    $scope.updating = false
                })
            }
        },
    })
)
